import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "highlight" }
const _hoisted_2 = { key: 1 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($setup.index > -1)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createElementVNode("span", null, _toDisplayString($setup.text.slice(0, $setup.index)), 1 /* TEXT */),
        _createElementVNode("span", _hoisted_1, _toDisplayString($setup.text.slice($setup.index, $setup.index + $setup.highlight.length)), 1 /* TEXT */),
        _createElementVNode("span", null, _toDisplayString($setup.text.slice($setup.index + $setup.highlight.length)), 1 /* TEXT */)
      ], 64 /* STABLE_FRAGMENT */))
    : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString($setup.text), 1 /* TEXT */))
}